<template>
  <b-modal
    id="modal-produto-grupos"
    size="medium"
    @show="showModalGrupos"
    @hidden="resetModalGrupos"
    @cancel="handleCancelModalGrupos"
    cancel-variant="outline-primary"
    cancel-title="+ Planos"
    @ok="handleOkModalGrupos"
    ok-variant="warning"
    ok-title="Confirmar">
    <template v-slot:modal-title>
      {{ produto.nome }}
    </template>

  <template #modal-footer="{ ok, cancel }">
      <b-button size="md" variant="outline-primary mr-auto" @click="handleExibirModalProdutos()" :disabled="block">
        Voltar
      </b-button>
      <b-button size="md" variant="outline-primary" @click="cancel()" :disabled="block" >
        + Planos
      </b-button>
      <b-button size="md" variant="warning" @click="ok()" :disabled="block">
        Confirmar
      </b-button>
  </template>

    <div class="text-center">
      <loader
          :width="'100px'"
          :height="'100px'"
          v-if="loadingGrupos" />
    </div>
    <div class="d-block text-center" v-if="grupos.length">
      <b-card no-body class="mb-1" v-for="grupo in grupos" :key="grupo.id">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            tabindex="3"
            block
            id="checkbox"
            @click="open"
            v-b-toggle="`accordion-${grupo.id}`"
            class="btn-control btn btn-link">
            <div class="text-capitalize text-left mb-1">
              {{ grupo.nome }}
            </div>

            <div class="text-left text-capitalize">
              <font-awesome-icon :icon="['fas', 'user-friends']" class="mr-1" />
              <span class="mr-3">{{ grupo.min_vidas }} a {{ grupo.max_vidas }}</span>
              <font-awesome-icon
                :icon="['fas', 'calendar-check']"
                class="mr-1"
                v-if="grupo.data_inicio"
              />
              <span class="mr-3" v-if="grupo.data_inicio">
                A partir {{ grupo.data_inicio | data }}
              </span>
              <font-awesome-icon
                :icon="['fas', 'hourglass-end']"
                class="mr-1"
                v-if="grupo.data_fim"
              />
              <span class="mr-3" v-if="grupo.data_fim">
                Até {{ grupo.data_fim | data }}
              </span>
              <font-awesome-icon
                :icon="['fas', 'hand-holding-usd']"
                class="mr-1"
                v-if="grupo.coparticipacao"
              />
              <span class="mr-3" v-if="grupo.coparticipacao">
                Coparticipação
              </span>
              <span class="mr-3" v-if="grupo.coparticipacao_porcentagem">
                {{grupo.coparticipacao_porcentagem | porcentagem}}
              </span>
              <font-awesome-icon
                :icon="['fas', 'globe']"
                class="mr-1"
                v-if="grupo.compulsorio"
              />
              <span v-if="grupo.compulsorio">Compulsório</span>

              <font-awesome-icon
                :icon="['fas', 'user-tie']"
                class="mr-1"
                v-if="grupo.mei"
              />
              <span v-if="grupo.mei">Aceita MEI</span>
            </div>
          </b-button>
        </b-card-header>
        <b-collapse
          :id="`accordion-${grupo.id}`"
          accordion="produtos-accordion"
          role="tabpanel">
          <b-card-body class="responsive pt-1 pb-1">
            <div class="row">
              <div class="col-12">
                <loader
                  :width="'100px'"
                  :height="'100px'"
                  v-if="block" />
              </div>
              <div class="col-12" style="padding-right: none"
                v-for="plano in grupo.planos" :key="plano.id">
                <div class="checkBox-ml grupo-botoes text-capitalize bg-white text-dark w-100 custom-control custom-checkbox">
                  <input
                    :id="`${cenario.id}-plano-${plano.id}`"
                    type="checkbox"
                    class="custom-control-input"
                    value="true"
                    v-model="plano.checked"
                    data-plano="true"
                    :data-cenarioId="cenarioId"
                    @change="updatePlano"
                    :disabled="block || plano.checked">
                    <label
                      :for="`${cenario.id}-plano-${plano.id}`"
                      class="custom-control-label"
                      :title="`${plano.checked ? 'Para remover o plano utilize a tela de comparativo.' : 'Clique aqui para adicionar o plano.' }`">
                      <nobr>
                        {{ plano.nome }} [{{plano.acomodacao == "Enfermaria" ? "E" : "A"}}]
                        <span class="plano-total">{{ plano.taxas.iof == true ? plano.calculo.total_iof : plano.calculo.total | dinheiro }}</span>
                      </nobr>
                    </label>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <p class="text-center" v-else-if="!loadingGrupos">
      Nenhum grupo encontrado
    </p>
  </b-modal>
</template>

<script>
import lodash from "lodash";
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader";

export default {
  data() {
    return {
      planoSelecionado: null,
      block: false,
    };
  },
  computed: {
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    ...mapGetters('modalFilter', ['getFilters']),
    ...mapGetters("cenario", {
      getId: "getId",
      cenario: "getCenario",
      cenarios: "getCenarios",
      faixa: "getFaixaEl"
    }),
    ...mapGetters("plano", {
      getGrupos: "getGrupos",
      planos: "getPlanos",
      loadingGrupos: "getLoading"
    }),
    ...mapGetters("operadora", {
      operadora: "getOperadora",
      plano: "getPlano",
      produto: "getProduto",
      administradora: "getAdministradora",
      entidade: "getEntidade"
    }),
    ...mapGetters("regiao", {
      regioes: "getRegioes"
    }),
    grupos() {
      // Removido validação para retornar os produtos da operadora
      // return this.plano.hasOwnProperty('id')
      //   ? this.getGrupos.filter(g => g.planos.filter(p => p.id == this.plano.id).length > 0)
      //   : this.getGrupos;
      return this.getGrupos;
    },
    lastId() {
      let id = this.cenarios.length
        ? this.cenarios.map(c => c.id).reduce((a, b) => Math.max(a, b))
        : 1
      return id
    },
    cenarioId() {
      return this.getId ? this.getId : this.lastId;
    },
    parseCompulorio() {
      return this.filtros.compulsorio == 2
        ? ""
        : this.filtros.compulsorio == 1
        ? "s"
        : "n";
    },
    parseCoparticipacao() {
      return this.filtros.coparticipacao == 2
        ? ""
        : this.filtros.coparticipacao == 1
        ? "s"
        : "n";
    },
    parseRegrasAceitacao() {
      return this.filtros.regras_aceitacao
        ? "s"
        : "n";
    },
    parseAcomodacao() {
      return this.filtros.acomodacao == 2
        ? ""
        : this.filtros.acomodacao == 1
        ? "a"
        : "e";
    },
    parseSomarTaxas() {
      //console.log('216:'+this.filtros.somar_taxas)
      return this.filtros.somar_taxas == 2
        ? "2"
        : "1";
    },
    parseMei() {
      return this.filtros.mei == 2
        ? ""
        : this.filtros.mei == 1
        ? "s"
        : "n";
    },
    parseCredenciado() {
      return this.filtros.credenciado
        ? this.filtros.credenciado.tipo + this.filtros.credenciado.id
        : "";
    },
    parseEntidade() {
      return this.filtros.entidade_profissao?.tipo == "e"
        ? this.filtros.entidade_profissao.value.id
        : "";
    },
    parseProfissao() {
      return this.filtros.entidade_profissao?.tipo == "p"
        ? this.filtros.entidade_profissao.value.id
        : "";
    }
  },
  watch: {
    grupos: {
      deep: true,
      handler(grupos) {
        this.planosSelecionados(grupos);
      }
    }
  },
  methods: {
    ...mapActions("plano", [
      "resetPlanos",
      "resetGrupos",
      "resetGrupoTree",
      "resetPlanosPorRede",
      "resetValores",
      "buscaGrupoPlano",
      "buscaGrupoPlanoAux",
      "buscaPlano"
    ]),
    ...mapActions('modalFilter', ['load']),
    ...mapActions("cenario", [
      "updateFaixaEl",
      "updateRedes",
      "updateRegioes",
      "atualizaCenarios",
      "atualizaPlanos",
      "removerPlano",
      "resetRedes",
      "resetRegioes",
    ]),
    ...mapActions('regiao', ['buscaRegiao']),
    updatePlano(e) {
      this.updateFaixaEl(e.target);
      this.block = true;
    },
    async atualizaValores(cenarios) {
      //console.log('atualiza Valores chama aqui')
       let vm = this,
         isPlano = null,
         cenarioId = null,
         faixaSlug = null;
       // console.log(this.faixa)
       if (this.faixa) {
         isPlano = this.faixa.getAttribute("data-plano");
         if (!isPlano) {
           cenarioId = this.faixa.getAttribute("data-cenarioId");
           faixaSlug = this.faixa.getAttribute("data-slug");
         }
         await vm.recalcularValores(cenarioId, cenarios);
         await this.updateFaixaEl(null)
       }
       setTimeout(function () {
         vm.block = false;
       }, 800);
    },
    async recalcularValores(cenarioId, cenarios) {
      console.log('ModalProdutoGrupos:recalcularValores');
      let vm = this;
      function totalVidas(cenarios) {
        var grupos_faixas = [];
        cenarios.forEach(cenario => {
          cenario.faixas.forEach(faixa => {
            let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
            if (key != -1) {
              grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
            } else {
              grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
            }
          })
        });
        return grupos_faixas
      }
      cenarios.forEach(cenario => {
        if (cenario.operadoras.length > 0) {
          cenario.operadoras.forEach(operadora => {
            operadora.grupos.forEach(grupo => {
              grupo.planos.forEach(async (plano) => {
                let cache = (grupo.planos.length > 1) ? 1 : 0; //se tiver selecionado mais de um plano, trazer a informação do cache
                console.log('322: buscaGrupoPlanoAux')
                await vm.buscaGrupoPlanoAux({
                  uf: plano.filtros.cidade.uf,
                  produto: plano.produto.id,
                  tipo_plano: plano.filtros.tipo_plano,
                  contratacao: plano.filtros.contratacao,
                  cidade: plano.filtros.cidade ? plano.filtros.cidade.id : "",
                  compulsorio: plano.filtros.compulsorio == 2 ? "" : plano.filtros.compulsorio == 1 ? "s" : "n",
                  coparticipacao: plano.filtros.coparticipacao == 2 ? "" : plano.filtros.coparticipacao == 1 ? "s" : "n",
                  acomodacao: plano.filtros.acomodacao == 2 ? "" : plano.filtros.acomodacao == 1 ? "a" : "e",
                  regras_aceitacao: plano.filtros.regras_aceitacao ? 's' : 'n',
                  somar_taxas: plano.filtros.somar_taxas,
                  credenciado: plano.filtros.credenciado ? plano.filtros.credenciado.tipo + plano.filtros.credenciado.id : "",
                  entidade: plano.filtros.entidade_profissao?.tipo == 'e' ? plano.filtros.entidade_profissao.value.id : '',
                  profissao: plano.filtros.entidade_profissao?.tipo == 'p' ? plano.filtros.entidade_profissao.value.id : '',
                  administradora: plano.filtros.administradora ? plano.filtros.administradora.id : "",
                  faixas: cenario.faixas ? cenario.faixas : "",
                  grupos_faixas: totalVidas(cenarios),
                  detalhes: "n",
                  cache: cache,
                  mei: plano.filtros.mei == 2 ? "" : plano.filtros.mei == 1 ? "s" : "n"
                }).then((grupos) => {
                  grupos.forEach(g => {
                    g.planos.forEach(p => {
                      if (plano.id == p.id) {
                        plano.alertas = p.hasOwnProperty("alertas") ? JSON.parse(JSON.stringify(p.alertas)) : [];
                        plano.calculo = JSON.parse(JSON.stringify(p.calculo));
                      }
                    })
                  });
                })
              });
            })
          });
        }
      });
    },
    open(event) {
     let checks = document.querySelectorAll(".btn-link-selecionado");
      checks.forEach(btn => {
        btn.classList.remove("btn-link-selecionado");
      });
      let check = event.target;
      check.classList.toggle("btn-link-selecionado");
    },
    validaPlano(grupos) {
      return grupos.map(grupo => grupo.planos)
        .reduce((acc, i) => acc.concat(i), [])
        .filter(plano => plano.checked);
    },
    agrupaRedes(planos) {
      return planos.map(plano => plano.rede_id)
        .reduce((acc, i) => acc.concat(i), [])
        .filter((value, index, self) => self.indexOf(value) === index)
    },
    async planosSelecionados(grupos) {
      console.log('ModalProdutoGrupos::planosSelecionados()')
      if (grupos.length > 0 && this.validaPlano(grupos).length > 0) {
        // Verifica se esta editando o plano
        if (this.plano.hasOwnProperty('id')) {
          this.resetRegioes();
        }

        let redes = this.agrupaRedes(
          this.validaPlano(grupos)
        );
        // console.log(redes)

        await this.updateRedes(redes)

        await this.buscaRegiao({
          uf: this.operadora.filtros.cidade.uf,
          cidade: '',// this.operadora.cidade ? this.operadora.cidade.id : '',
          credenciado: this.operadora.filtros.credenciado ? this.operadora.filtros.credenciado.tipo + this.operadora.filtros.credenciado.id : '',
          redes: this.cenario.redes
        })

        this.operadora.regioes = JSON.parse(JSON.stringify(this.regioes));

        await this.updateRegioes(
          JSON.parse(JSON.stringify(this.regioes))
        );

        await this.atualizaPlanos({
          grupos: JSON.parse(JSON.stringify(grupos)),
          operadora: JSON.parse(JSON.stringify(this.operadora)),
          plano: JSON.parse(JSON.stringify(this.plano)),
          produto: JSON.parse(JSON.stringify(this.produto)),
          filtros: JSON.parse(JSON.stringify(this.operadora.filtros))
        });

        await this.atualizaValores(this.cenarios);

        await this.load({
          filters: this.getFilters,
          recomendar: [],
          atuacao: [],
          modalidade: [],
          acomodacao: [],
          coparticipacao: [],
          reembolso: [],
          taxas_iof: [],
          informacoes: [],
          hospitais: this.cenarios,
          valores: [
            "00-18",
            "19-23",
            "24-28",
            "29-33",
            "34-38",
            "39-43",
            "44-48",
            "49-53",
            "54-58",
            "59-+"
          ],
          resumos: []
        });
      }
    },
    async resetModalGrupos() {
      console.log('ModalProdutoGrupos::resetModalGrupos()')
      this.block = false
      await this.resetPlanos()
      await this.resetGrupos()
      await this.resetGrupoTree()
      await this.resetPlanosPorRede()
      await this.resetValores()
    },
    async showModalGrupos() {
      //console.log('ModalProdutoGrupos::showModalGrupos()')
      function totalVidas(cenarios) {
        var grupos_faixas = [];
        cenarios.forEach(cenario => {
          cenario.faixas.forEach(faixa => {
            let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
            if (key != -1) {
              grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
            } else {
              grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
            }
          })
        });
        return grupos_faixas
      }
      console.log('466: buscagrupoplano')
      await this.buscaGrupoPlano({
        uf: this.operadora.filtros.cidade.uf,
        produto: this.produto.id,
        tipo_plano: this.operadora.filtros.tipo_plano,
        contratacao: this.operadora.filtros.contratacao,
        cidade: this.operadora.filtros.cidade ? this.operadora.filtros.cidade.id : "",
        compulsorio: this.parseCompulorio,
        coparticipacao: this.parseCoparticipacao,
        acomodacao: this.parseAcomodacao,
        regras_aceitacao: this.parseRegrasAceitacao,
        somar_taxas: this.parseSomarTaxas,
        credenciado: this.parseCredenciado,
        entidade: this.entidade ? this.entidade.id : "",
        profissao: "", //this.operadora.filtros.entidade_profissao?.tipo == 'p' ? this.operadora.filtros.entidade_profissao.value.id : '',
        administradora: this.administradora ? this.administradora.id : "",
        faixas: this.cenario.faixas ? this.cenario.faixas : "",
        grupos_faixas: totalVidas(this.cenarios),
        detalhes: "n",
        cache: null,
        mei: this.parseMei
      });
    },
    handleCancelModalGrupos() {
    },
    handleOkModalGrupos() {
      this.$bvModal.hide("modal-produtos-grupos");
      this.$bvModal.hide("modal-produtos");
      this.$bvModal.hide("modal-operadora-produtos");
      this.$bvModal.hide("modal-operadora");
    },
    handleExibirModalProdutos() {
      this.$bvModal.hide("modal-produto-grupos");
      if(this.operadora.filtros.contratacao != 'a') {
        this.$bvModal.show("modal-produtos");
      } else {
        this.$bvModal.show("modal-produtos-adesao");
      }
    }
  },
  components: {
    Loader
  }
};
</script>

<style scoped>
.btn-link {
  color: #796348 !important;
  font-weight: 500 !important;
}
.btn-link-selecionado {
  background-color: #f3bb453d !important;
  color: #796348 !important;
}

.text-dark {
  color: #545454 !important;
}

.grupo-botoes {
  font-size: 0.8rem !important;
  font-weight: 500 !important;
}

.btn-control > * {
  pointer-events: none;
}

.checkBox-ml {
  display: flex;
  margin-left: 10px;

}

.col-12 {
  padding: 0 5px;
}

.responsive {
  overflow-x: auto;
  overflow-y: visible;
}

.plano-total{
  color:#f4c265;
  font-size: 0.7rem;
}

@media only screen and (max-width: 700px) {
  .plano-total{
    font-size: 15px;
  }
}
</style>
<style>
.modal-medium {
  max-width: 630px !important;
}
</style>
